<div class="pronunciation-question">
  <div class="pronunciation-question-words-list">

    <app-icon-button
      class="d-block mr-3"
      [icon]="speech ? 'pause-circle' : 'play'"
      [isLoading]="isSpeechLoading"
      [hasBorder]="true"
      [tooltip]="(speech ? 'CHAPTERS.stop_listening' : 'CHAPTERS.start_listening') | translate"
      tooltipPosition="below"
      [ariaLabel]="speech ? 'Stop listening' : 'Start listening'"
      (clicked)="toggleListeningMode()">
    </app-icon-button>

    @for (item of words; track item) {
      <div
        class="pronunciation-word"
        [class.failed]="item.score !== -1 && item.score < PASS_RATE_SCORE"
        [class.success]="item.score !== -1 && item.score >= PASS_RATE_SCORE">
        {{ item.word }}
      </div>
    }
  </div>

  <div class="pronunciation-question-record">
    <app-audio-record
      [isLoading]="isLoading"
      [audioMaxLength]="15"
      [canUpload]="false"
      [showMaxLengthMessage]="false"
      (audioRecorded)="fileChanged($event)">
    </app-audio-record>
  </div>

</div>
